<template>
  <patientDetailComponent :isMy="true"></patientDetailComponent>
</template>
<script>

const files = require.context('/', false, /\.vue$/);
const suffixList = files.id
  .split(' ')[0]
  .split('/')
  .filter((a, b) => b > 2);
import patientDetailComponent from '@/components/patient/patientDetail.vue'
export default {
  name: `fetalMonitoruserDetail`,
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {
  },
  components: {
    patientDetailComponent
  }
}
</script>